const pauseAndReset = (audioElem) => {
	if (!audioElem) return;
	audioElem.pause();
	audioElem.currentTime = 0;
};

const playPause = (audioElem, otherAudioElemsObject = {}, onBlocked) => {
	if (audioElem.paused) {
		Object.keys(otherAudioElemsObject).forEach((key) => {
			pauseAndReset(otherAudioElemsObject[key]);
		});

		const promise = audioElem.play();
		if (promise !== undefined) {
			promise.catch((err) => {
				if (err.name === 'NotAllowedError') {
					// Browser autoplay policy blocked it — user must tap
					if (typeof onBlocked === 'function') onBlocked();
				} else {
					// Network/decode error — force reload and retry once
					audioElem.load();
					audioElem.play().catch(() => {
						if (typeof onBlocked === 'function') onBlocked();
					});
				}
			});
		}
	} else {
		pauseAndReset(audioElem);
	}
};

export default playPause;
